var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6511 14.0605L16.229 23.4767L10.3496 17.6261",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1387 29.9804L19.3196 38.4675C18.5155 38.9697 17.4854 38.9697 16.6814 38.4675L2.86228 29.9804C2.10851 29.5284 1.65625 28.7249 1.65625 27.8461V3.66528C1.65625 2.28424 2.7869 1.1543 4.16881 1.1543H31.807C33.1889 1.1543 34.3196 2.28424 34.3196 3.66528V27.8461C34.3196 28.7249 33.8924 29.5284 33.1387 29.9804Z",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.b17e1f5155b1b4b037a6a746674a5c7b.svg";
export { ForwardRef as ReactComponent };